import { Tag } from "antd";

export default function DeactivatedUserTag() {
  return <Tag color="warning">deactivated</Tag>;
}
